import { useState, useEffect } from "react";
import { isServerDown, subscribeServer } from "../services/offline/serverReach";

// online = the browser has a network AND the server answers
// (Wi-Fi without internet counts as offline)
function useNetworkStatus() {
  const [browserOnline, setBrowserOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true,
  );
  const [serverDown, setServerDown] = useState(isServerDown);

  useEffect(() => {
    const handleOnline = () => setBrowserOnline(true);
    const handleOffline = () => setBrowserOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    const unsubscribe = subscribeServer(setServerDown);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      unsubscribe();
    };
  }, []);

  return { isOnline: browserOnline && !serverDown };
}

export default useNetworkStatus;
